import { Notification } from 'uiv';
import { TTranslateObject } from '@/types';
import {
  getTranslate,
  getTranslateWithValue,
} from '@/helpers/translateHelpers';

export default class NotificationService {
  static errorRequest(err: any) {
    const REQUEST_ERROR = getTranslate('notifications.errorRequest');

    Notification.notify.error({
      title: REQUEST_ERROR,
    });
    throw new Error(err);
  }

  static warning(
    value: string | TTranslateObject,
    value2: string | TTranslateObject = ''
  ) {
    let title: string, content: string;

    if (typeof value === 'object') {
      title = getTranslateWithValue(value.message, value.options);
    } else {
      title = getTranslate(value) || value;
    }

    if (typeof value2 === 'object') {
      content = getTranslateWithValue(value2.message, value2.options);
    } else {
      content = getTranslate(value2) || value2;
    }

    Notification.notify.warning({
      title,
      content,
    });
    console.warn('Warning: ', title);
  }

  static confirmDelete(message: string): void {
    Notification.notify.success({
      title: getTranslate('notifications.success'),
      content: message,
      duration: 1000,
    });
  }

  static cancelDelete(): void {
    Notification.notify.info({
      title: getTranslate('notifications.cancelDelete'),
      duration: 1000,
    });
  }
}
